import React from 'react';
import CancellationDetail from '../../components/templates/CancellationTemplate/CancellationDetail';

const VSCancellationDetailPage = () => {
	return <CancellationDetail />;
};
export default VSCancellationDetailPage;
